var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeture4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_200_178",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 75
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 147",
    width: 75,
    height: 75,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_200_178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.0311 49.8549C31.0311 48.8369 31.2089 47.8484 30.7496 47.4648C29.9497 46.7714 27.1202 48.0992 26.4239 47.3025C25.7276 46.5058 27.4609 43.9091 26.8831 43.0091C26.3054 42.1092 23.2092 42.6255 22.7648 41.6518C22.3203 40.678 24.7351 38.701 24.424 37.6683M56.1857 25.939H71C71 25.939 71 37.742 51.7415 37.742M39.89 23.18L54.7043 4C54.7043 4 62.4522 12.8523 55.0154 26.0422C54.5649 26.8981 54.0704 27.7304 53.534 28.5356M35.268 34.5995C18.7501 33.4782 6.51351 48.0107 3.18031 43.4518C0.795209 40.1469 22.5277 21.8669 41.4307 23.0472M53.2229 31.1766C53.6821 38.0519 49.6971 43.6878 45.8158 48.6599C42.6899 52.6287 38.8975 56.0368 35.7569 59.9613C33.5495 62.735 31.8015 65.7743 29.7571 68.6218C29.3701 69.2089 28.7918 69.6453 28.1195 69.8574C27.4473 70.0695 26.7221 70.0444 26.0663 69.7862C25.4105 69.5281 24.864 69.0527 24.519 68.4402C24.174 67.8277 24.0515 67.1154 24.1721 66.4235C25.5647 59.4302 29.6238 52.7467 33.6236 46.8451C36.3494 42.8026 37.5938 40.6633 38.0679 38.9814M53.2229 31.8405C53.2229 36.7295 49.2433 40.6928 44.3343 40.6928C39.4253 40.6928 35.4458 36.7295 35.4458 31.8405C35.4458 26.9515 39.4253 22.9882 44.3343 22.9882C49.2433 22.9882 53.2229 26.9515 53.2229 31.8405Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeture4);
export default __webpack_public_path__ + "static/media/feture4.b539fcbab5d6b7a76b33bcf97c215b7b.svg";
export { ForwardRef as ReactComponent };